import { AxiosError } from "axios";
import { ApiErrorResponse } from "../lib/api/api.types";

export const handleApiError = (error: unknown): string => {
  if (error instanceof AxiosError) {
    const axiosError = error as AxiosError<ApiErrorResponse>;

    if (axiosError.response?.data) {
      const apiError = axiosError.response.data;

      // Directly use message from API response
      if (apiError.message) {
        return apiError.message;
      }

      if (apiError.errors && typeof apiError.errors === "object") {
        const errorMessages = Object.values(apiError.errors)
          .flat()
          .filter((msg) => typeof msg === "string")
          .join(", ");
        if (errorMessages) return errorMessages;
      }
    }

    const status = axiosError.response?.status;
    switch (status) {
      case 400:
        return "Geçersiz istek.";
      case 401:
        return "Oturum süreniz doldu. Lütfen tekrar giriş yapın.";
      case 403:
        return "Bu işlemi yapmaya yetkiniz yok.";
      case 404:
        return "İstenilen kaynak bulunamadı.";
      case 422:
        return "Gönderilen veriler geçersiz.";
      case 500:
        return "Sunucu hatası. Lütfen daha sonra tekrar deneyin.";
    }

    if (axiosError.message === "Network Error") {
      return "Ağ hatası. Lütfen internet bağlantınızı kontrol edin.";
    }

    if (axiosError.message) {
      return axiosError.message;
    }
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === "string") {
    return error;
  }

  return "Bilinmeyen bir hata oluştu.";
};
